import React, { useState } from 'react';
import { api } from '../api';
import '../css/contact.css';
import FadeInSection from '../components/FadeInSection';

export default function Contact() {
  const [form, setForm] = useState({ name: '', email: '', subject: '', message: '' });
  const [sent, setSent] = useState(false);

  const submit = async e => {
    e.preventDefault();
    const res = await api.post('/contact', form);
    if (res.success) setSent(true);
  };

  return (
    <div className="contact-page">
      <FadeInSection direction="up">
      <section className="contact-hero">
        <div className="container">
          <span className="section-tag light">Get In Touch</span>
          <h1 className="light">Contact Us</h1>
          <p className="section-sub light">Ready to start? Let's talk.</p>
        </div>
      </section>
      </FadeInSection>

      <FadeInSection direction="left">
      <section className="section section-white">
        <div className="container">
          <div className="contact-grid">
            <div className="contact-info">
              <h2>Let's Work Together</h2>
              <div className="contact-items">
                <div className="contact-item">
                  <span>📞</span>
                  <div>
                    <strong>Phone / WhatsApp</strong>
                    <a href="tel:+9647781428130">+964 778 142 8130</a>
                  </div>
                </div>
                <div className="contact-item">
                  <span>✉️</span>
                  <div>
                    <strong>Email</strong>
                    <a href="mailto:agencyamko@gmail.com">agencyamko@gmail.com</a>
                  </div>
                </div>
                <div className="contact-item">
                  <span>📍</span>
                  <div>
                    <strong>Location</strong>
                    <p>Erbil, Kurdistan Region, Iraq</p>
                  </div>
                </div>
              </div>
              <div className="social-btns">
                <a href="https://wa.me/9647781428130" target="_blank" rel="noreferrer" className="social-btn">💬 WhatsApp</a>
                <button className="social-btn">📸 Instagram</button>
                <button className="social-btn">👥 Facebook</button>
              </div>
            </div>
            <div className="contact-form-wrap">
              {sent ? (
                <div className="sent-box">
                  <div>✅</div>
                  <h3>Message Sent!</h3>
                  <p>We'll get back to you soon.</p>
                </div>
              ) : (
                <form onSubmit={submit} className="form">
                  <div className="form-row">
                    <input placeholder="Your Name *" required value={form.name} onChange={e => setForm(p => ({ ...p, name: e.target.value }))} />
                    <input type="email" placeholder="Email *" required value={form.email} onChange={e => setForm(p => ({ ...p, email: e.target.value }))} />
                  </div>
                  <input placeholder="Subject" value={form.subject} onChange={e => setForm(p => ({ ...p, subject: e.target.value }))} />
                  <textarea rows={5} placeholder="Your Message *" required value={form.message} onChange={e => setForm(p => ({ ...p, message: e.target.value }))} />
                  <button type="submit" className="btn-primary">Send Message →</button>
                </form>
              )}
            </div>
          </div>
        </div>
      </section>
      </FadeInSection>
    </div>
  );
}
